import type { FlowId } from '../types';
import type { WizardFlowDefinition } from './flowTypes';
import { passportFlow } from './flows/passportFlow';
import { pasConsentFlow } from './flows/pasConsentFlow';
import { driverFlow } from './flows/driverFlow';
import { driverConsentFlow } from './flows/driverConsentFlow';
import { bookingFlow } from './flows/bookingFlow';
import { cancelFlow } from './flows/cancelFlow';

const flowRegistry: Record<FlowId, WizardFlowDefinition> = {
  pas: passportFlow,
  pas_samtykke: pasConsentFlow,
  koerekort: driverFlow,
  koerekort_samtykke: driverConsentFlow,
  tidsbestilling: bookingFlow,
  afbestil: cancelFlow
};

const defaultFlow = passportFlow;
const defaultFlowId: FlowId = defaultFlow.id as FlowId;
const FLOW_ALIASES: Record<string, FlowId> = {
  samtykke: 'pas_samtykke'
};

const isFlowId = (value: string): value is FlowId => value in flowRegistry;

export const normalizeFlowId = (flowId?: string | null): FlowId => {
  if (!flowId) {
    return defaultFlowId;
  }

  const candidate = FLOW_ALIASES[flowId] ?? flowId;
  return isFlowId(candidate) ? candidate : defaultFlowId;
};

export const resolveFlow = (flowId?: string | null): WizardFlowDefinition => {
  const id = normalizeFlowId(flowId);
  return flowRegistry[id] ?? defaultFlow;
};

export const listFlows = (): WizardFlowDefinition[] => {
  return [passportFlow, pasConsentFlow, driverFlow, driverConsentFlow, bookingFlow, cancelFlow];
};
